<template>
  <!-- <page> -->
  <div :load="doInit">
    <v-container fluid grid-list-md>
      <v-layout row wrap>
        <v-flex xs12 sm12 md12 lg12>
          <v-expansion-panels v-model="panel1" multiple>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon> {{ labels.filters }}</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content class="ePanelHeaderColor">
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-sm>
                      <v-layout row wrap>
                        <!-- Policy No. -->
                        <v-flex xs12 sm12 md12 lg12>
                          <v-text-field
                            v-model="reportForm.polNo"
                            :label="labels.polNo"
                            :error-messages="errors.collect('polNo')"
                            :data-vv-as="labels.polNo"
                            data-vv-name="polNo"
                            append-icon="mdi-magnify"
                            @click:append="getHelpList()"
                            readonly
                            v-validate="'required'"
                          ></v-text-field>
                        </v-flex>
                        <!-- Renewal Count -->
                        <v-flex xs12 sm12 md12 lg12>
                          <v-text-field
                            v-model="reportForm.renCnt"
                            :label="labels.renCnt"
                            :error-messages="errors.collect('renCnt')"
                            :data-vv-as="labels.renCnt"
                            data-vv-name="renCnt"
                            readonly
                            v-validate="'required'"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-flex>

        <v-flex xs12 sm6 md6 lg6>
          <v-btn class="mr-2" color="primary" type="submit" :loading="loading" @click.prevent="doExport">
            <v-icon left dark>mdi-file-export</v-icon>
            {{ labels.export }}
          </v-btn>
          <v-btn-toggle dense mandatory v-model="reportForm.format">
            <v-btn text v-for="format in supportedList" :key="format.value" :value="format.value">
              <span>{{ format.label }}</span>
              <v-icon :color="format.color">{{ format.icon }}</v-icon>
            </v-btn>
          </v-btn-toggle>
        </v-flex>
      </v-layout>
    </v-container>

    <!-- Policy No. HelpList -->
      <v-dialog v-model="polNoList" width="1280px">
        <policy-help-list @close="polNoList = false" @assign-policy-info="assignPolicy" polHeader="polHeader2"></policy-help-list>
      </v-dialog>
  </div>
  <!-- </page> -->
</template>

<script>
import { extractMenu } from '@/utils/extract'
import { reportFormat } from '@/const/report'
import MessageMixin from '@/mixins/message'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'
import PolicyHelpList from '@/components/core/common/dialog/PolicyHelpList'

export default {
  data() {
    return {
      labels: {
        polNo: 'Policy No.',
        renCnt: 'Renewal Count',
        format: 'Export Format',
        export: 'Export to',
        filters: 'Selection Criteria'
      },
      reportForm: {
        polNo: undefined,
        renCnt: 0,
        format: 'PDF'
      },
      // HelpList
      polNoList: false,
      // Other
      menu: {},
      supportedFormat: [],
      loading: false,
      panel1: [0]
    }
  },
  computed: {
    rptMenu() {
      return this.$store.state.reports.uwReports.menu
    },
    supportedList() {
      const result = []
      if (this.supportedFormat && this.supportedFormat.length > 0) {
        this.supportedFormat.map(format => {
          if (reportFormat[format] === reportFormat.PDF) { // OS-927 remove excel
            result.push(reportFormat.PDF)
          }
        })
      }
      return result
    }
  },
  methods: {
    async doInit() {
      try {
        if (this.$store.state.reports.uwReports.menu !== 1) {
          await this.$store.dispatch('uwReportsInit')
        }
        const apiURI = this.rptMenu.initAutoRenCvrLet
        const result = await this.$http.get(apiURI)
        if (result.data) {
          const { data } = result
          if (data) {
            this.supportedFormat = data.data.format
            this.menu = extractMenu(result.data._links)
          }
        }
      } catch (err) {
        throw err
      }
    },
    getHelpList() {
      this.polNoList = true
    },
    assignPolicy(data) {
      this.reportForm.polNo = data.polNo
      this.reportForm.renCnt = data.renCnt
      this.polNoList = false
    },
    doClose() {
      this.polNoList = false
    },
    doExport() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          this.processExport()
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async processExport() {
      // const apiURI = this.menu.genAutoBatchRenewal
      const apiURI = this.menu.genRenCvrLet
      if (apiURI) {
        try {
          this.loading = true
          await this.$http.post(apiURI, this.reportForm)
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.loading = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    }
  },
  created() {
    this.doInit()
  },
  mixins: [MessageMixin, commonAjaxMixin],
  components: {
    PolicyHelpList
  }
}
</script>
